export default "__VITE_ASSET__DFOMpr7V__"